import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { find, orderBy } from 'lodash'
import { connect } from 'react-redux'
import { getDate } from '../../../utils/DateUtil'
import DtoDetailStationSamplingSurfacePoint from '../../dto/DtoDetailStationSamplingSurfacePoint'
import DtoSupport from '../../../referential/dto/DtoSupport'
import i18n from 'simple-react-i18n'

class SamplingSurfacePointPanel extends Component {
	constructor(props) {
		super(props)
	}

	getLines = () => {
		const samplings = orderBy(this.props.samplingSurfacePoints, ['endDate', 'code'], ['desc', 'asc'])

		const data = samplings.map(samplingSurfacePoints => {
			const support = samplingSurfacePoints.supportCode ? find(this.props.supports, (o) => {
				return o.id == samplingSurfacePoints.supportCode
			}) : null
			if (support) {
				return Object.assign({}, samplingSurfacePoints, {
					name: support.name
				})
			}
			return samplingSurfacePoints
		})

		return data.map(samplingSurfacePoints => {
			const beginDate = getDate(samplingSurfacePoints.beginDate)
			const endDate = getDate(samplingSurfacePoints.endDate)
			const begin = beginDate ? beginDate : ''
			const end = endDate ? endDate : 'En cours'
			return (
				<li className='collection-item'>
					<span
						className='title'>{ i18n.code }: { samplingSurfacePoints.code } - { i18n.support } : { samplingSurfacePoints.name + ' [' + samplingSurfacePoints.supportCode + ']' }</span>
					<p>
						<b>X : </b>{ samplingSurfacePoints.xCoordinate }<br/>
						<b>Y : </b>{ samplingSurfacePoints.yCoordinate }<br/>
						{ begin + ' - ' + end }
					</p>
				</li>
			)
		})
	}

	render() {
		return (
			<div className='row no-margin white-background'>
				<div className='col s12 no-padding'>
					<div className='row primary-light white-text no-margin'>
						<div className='col l12'><h5>{ i18n.point.samplingPoints } : { this.props.samplingSurfacePoints.length }</h5></div>
					</div>
					<div className='row no-margin'>
						<ul className='collection'>
							{ this.getLines() }
						</ul>
					</div>
				</div>
			</div>
		)
	}
}

SamplingSurfacePointPanel.propTypes = {
	samplingSurfacePoints: PropTypes.arrayOf(PropTypes.objectOf(DtoDetailStationSamplingSurfacePoint)),
	supports: PropTypes.arrayOf(PropTypes.instanceOf(DtoSupport))
}

SamplingSurfacePointPanel.defaultProps = {
	samplingSurfacePoints: [],
	supports: []
}

const mapStateToProps = store => {
	return {
		samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
		supports: store.ReferentialReducer.supports
	}
}

export default connect(mapStateToProps)(SamplingSurfacePointPanel)



// WEBPACK FOOTER //
// ./src/station/components/samplingSurfacePoint/SamplingSurfacePointPanel.js